var map = {
	"./flow/minimal/index.js": 918,
	"./flow/simple/index.js": 922,
	"./nav/simple/index.js": 931,
	"./news/simple/index.js": 933,
	"./pdf/index.js": 936,
	"./web/index.js": 940,
	"./youtube/index.js": 943
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2054;



//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/plugins ^\.\/.*\/index\.js$
// module id = 2054
// module chunks = 2